/* Live logo mockups: puts the visitor's uploaded logo (site-wide logo preview,
   assets/bmn-site-logo.js) onto every .bmn-lm tile, or the placeholder when there is none. */
(function () {
  var KEY = 'bmn_site_logo_v1', HIDE = 'bmn_site_logo_hide_v1';
  function read(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  function logo() {
    var api = window.BMNSiteLogo;
    if (api && typeof api.get === 'function') { var l = api.get(); return l && l.src ? l.src : null; }
    if (read(HIDE) === '1') return null;
    try { var r = JSON.parse(read(KEY) || 'null'); return r && r.src ? r.src : null; } catch (e) { return null; }
  }
  function apply() {
    var src = logo();
    document.querySelectorAll('.bmn-lm').forEach(function (t) {
      var img = t.querySelector('.bmn-lm__logo img'); if (!img) return;
      var want = src || img.getAttribute('data-ph');
      if (img.getAttribute('src') !== want) img.setAttribute('src', want);
      t.classList.toggle('is-own', !!src);
    });
    document.querySelectorAll('[data-lm-state]').forEach(function (el) {
      el.textContent = src ? el.getAttribute('data-lm-on') : el.getAttribute('data-lm-off');
    });
  }
  function upload(e) {
    var api = window.BMNSiteLogo;
    if (api && typeof api.pick === 'function') { e.preventDefault(); api.pick(); }
  }
  function boot() {
    apply();
    document.addEventListener('click', function (e) { var b = e.target.closest && e.target.closest('[data-lm-upload]'); if (b) upload(e); });
    document.addEventListener('bmn:sitelogo', apply);
    window.addEventListener('storage', function (e) { if (e.key === KEY || e.key === HIDE) apply(); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
